import { useEffect, useRef } from 'react';
import { useIntersection } from 'react-use';
type Params = {
  onReachBottom?: () => void;
  intersectionOptions?: IntersectionObserverInit;
};
export const useReachBottom = ({
  onReachBottom,
  intersectionOptions,
}: Params) => {
  const bottomTargetRef = useRef<HTMLDivElement | null>(null);
  const intersection = useIntersection(bottomTargetRef, {
    root: intersectionOptions?.root ?? null,
    rootMargin: intersectionOptions?.rootMargin ?? '0px',
    threshold: intersectionOptions?.threshold ?? 1,
  });
  const intersectionRatio = intersection?.intersectionRatio ?? 0;
  useEffect(() => {
    if (intersectionRatio) {
      onReachBottom?.();
    }
  }, [intersectionRatio, onReachBottom]);
  return { bottomTargetRef };
};
